// extracted by mini-css-extract-plugin
export default {"wrapperMenu":"MainPage_wrapperMenu__fPAOC","logoutIcon":"MainPage_logoutIcon__FbPB4","wrapperPages":"MainPage_wrapperPages__807Gj"};